"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formInputTheme = void 0;
exports.getBackgroundColor = getBackgroundColor;
exports.getBorderColor = getBorderColor;
exports.getBorderWidth = getBorderWidth;
exports.getStylingState = getStylingState;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var colors = _interopRequireWildcard(require("../../../constants/colors"));
const formInputTheme = (0, _sdsThemeInternal.themed)({
  backgroundColor: {
    rest: {
      "lodestar-light": "transparent",
      "ursa-light": (0, _designTokensReact.color)("color--background--surfaces--work")
    },
    readonly: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--weaker"),
      "ursa-light": (0, _designTokensReact.color)("color--background--surfaces--work")
    },
    error: {
      "lodestar-light": "transparent",
      "ursa-light": (0, _designTokensReact.color)("color--background--surfaces--work")
    },
    underlined: "transparent"
  },
  borderColor: {
    error: (0, _designTokensReact.color)("color--border--error--default"),
    // We have a disconnect between Lodestar and Ursa here. In Lodestar, the focus color is used
    // when the input is focused EVEN in the error state. This is becaus the border is the only
    // indication of focus or error. If it didn't get the focus treatment, you couldn't tell if
    // it was focused in the error state. In Ursa, however, the focus indicator is a ring around
    // the input so the border AND focus ring can show.
    errorFocus: {
      // no equivalent semantic token for this — same as the Button blue colors
      "lodestar-light": colors.focus,
      "ursa-light": (0, _designTokensReact.color)("color--border--error--default")
    },
    focus: {
      "lodestar-light": colors.focus,
      "ursa-light": (0, _designTokensReact.color)("color--border--primary--default")
    },
    hover: {
      "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--default"),
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--strong")
    },
    readonly: {
      "lodestar-light": (0, _designTokensReact.color)("color--background--neutral--weaker"),
      "ursa-light": (0, _designTokensReact.color)("color--background--neutral--weakest")
    },
    rest: {
      "lodestar-light": (0, _designTokensReact.color)("color--border--neutral--weak"),
      "ursa-light": (0, _designTokensReact.color)("color--border--neutral--weaker")
    }
  },
  borderWidth: {
    rest: {
      "lodestar-light": 2,
      "ursa-light": 1
    },
    active: {
      "lodestar-light": 2,
      "ursa-light": 2
    },
    error: {
      "lodestar-light": 2,
      "ursa-light": 2
    }
  },
  borderRadius: {
    "lodestar-light": _designTokens.border.radius10,
    "ursa-light": _designTokens.border.radius30
  },
  searchInputButtonRadius: {
    "lodestar-light": _designTokens.border.radius10,
    "ursa-light": _designTokens.border.radius20
  },
  searchInputButtonSize: {
    "32": {
      "lodestar-light": "30px",
      "ursa-light": "24px"
    },
    "40": {
      "lodestar-light": "30px",
      "ursa-light": "32px"
    }
  },
  padding: {
    // these are used if there is no contentBefore/contentAfter
    default: {
      rest: {
        // 12px - 1px for the border.
        "lodestar-light": 10,
        // 8px - 1px for the border.
        "ursa-light": 7
      },
      active: {
        // 12px - 2px for the thicker active border.
        "lodestar-light": 10,
        // 8px - 2px for the border.
        "ursa-light": 6
      },
      error: {
        // 12px - 2px for the thicker error border.
        "lodestar-light": 10,
        // 8px - 2px for the border.
        "ursa-light": 6
      }
    },
    // used for the gap between the input and the contentBefore/contentAfter
    betweenContent: 8,
    // This is used on the gap between the left bounding border and the contentLeft, if present.
    left: {
      rest: {
        // 8px - 1px for the border.
        "lodestar-light": 10,
        "ursa-light": 7
      },
      active: {
        // 8px - 2px for the thicker error border.
        "lodestar-light": 10,
        "ursa-light": 6
      },
      error: {
        // 8px - 2px for the thicker error border.
        "lodestar-light": 10,
        "ursa-light": 6
      }
    },
    // This is used on the right side of the inputs as the gap between
    // the border and the contentRight's bounding box, if present.
    right: {
      rest: {
        "lodestar-light": 6,
        "ursa-light": 3
      },
      active: {
        // 4 - 2px for the thicker error border.
        "lodestar-light": 6,
        "ursa-light": 2
      },
      error: {
        // 4 - 2px for the thicker error border.
        "lodestar-light": 6,
        "ursa-light": 2
      }
    },
    top: {
      "32": {
        rest: {
          "lodestar-light": 4.5,
          "ursa-light": 6
        },
        active: {
          "lodestar-light": 4.5,
          "ursa-light": 5
        },
        error: {
          "lodestar-light": 4.5,
          "ursa-light": 5
        }
      },
      "40": {
        rest: {
          "lodestar-light": 8.5,
          "ursa-light": 10
        },
        active: {
          "lodestar-light": 8.5,
          "ursa-light": 9
        },
        error: {
          "lodestar-light": 8.5,
          "ursa-light": 9
        }
      }
    },
    bottom: {
      "32": {
        rest: {
          "lodestar-light": 4.5,
          "ursa-light": 6
        },
        active: {
          "lodestar-light": 4.5,
          "ursa-light": 5
        },
        error: {
          "lodestar-light": 4.5,
          "ursa-light": 5
        }
      },
      "40": {
        rest: {
          "lodestar-light": 8.5,
          "ursa-light": 10
        },
        active: {
          "lodestar-light": 8.5,
          "ursa-light": 9
        },
        error: {
          "lodestar-light": 8.5,
          "ursa-light": 9
        }
      }
    }
  },
  textColor: {
    rest: (0, _designTokensReact.color)("color--text--neutral--strong"),
    readonly: (0, _designTokensReact.color)("color--text--neutral--weaker")
  },
  placeholderColor: {
    rest: (0, _designTokensReact.color)("color--text--neutral--weaker"),
    hover: {
      "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--default"),
      "ursa-light": (0, _designTokensReact.color)("color--text--neutral--weaker")
    }
  },
  placeholderTop: {
    "32": {
      "lodestar-light": "7px",
      "ursa-light": "7px"
    },
    "40": {
      "lodestar-light": "11px",
      "ursa-light": "11px"
    }
  },
  fontSize: {
    box: {
      // Inherit is needed here to override some UA styles which for some reason set the
      "ursa-light": "14px",
      // font-size to sub-px values like 13.333px. Chrome, why?
      "lodestar-light": "inherit"
    },
    underline: "15px"
  },
  fontWeight: {
    "lodestar-light": 500,
    "ursa-light": 400
  },
  lineHeight: 18,
  focusRing: {
    offset: {
      "lodestar-light": 2,
      "ursa-light": 1
    },
    enabled: {
      "lodestar-light": true,
      "ursa-light": true
    }
  },
  height: {
    "32": {
      "lodestar-light": 32,
      "ursa-light": 32
    },
    "40": {
      "lodestar-light": 40,
      "ursa-light": 40
    }
  }
});
exports.formInputTheme = formInputTheme;
function getBorderColor(_ref) {
  let {
    validationState,
    isFocused,
    themeMode,
    focusMode,
    isDisabled,
    isHovered
  } = _ref;
  const isError = validationState === "error";
  const isKeyboardFocused = focusMode === "keyboard";
  if (isFocused && isError) {
    return formInputTheme.borderColor.errorFocus(themeMode);
  } else if (isDisabled) {
    return formInputTheme.borderColor.readonly(themeMode);
  } else if (isFocused && !isKeyboardFocused) {
    return formInputTheme.borderColor.focus(themeMode);
  } else if (isFocused && isKeyboardFocused) {
    return formInputTheme.borderColor.rest(themeMode);
  } else if (isError) {
    return formInputTheme.borderColor.error(themeMode);
  } else if (isHovered) {
    return formInputTheme.borderColor.hover(themeMode);
  } else {
    return formInputTheme.borderColor.rest(themeMode);
  }
}
function getBackgroundColor(_ref2) {
  let {
    isDisabled,
    themeMode
  } = _ref2;
  if (isDisabled) {
    return formInputTheme.backgroundColor.readonly(themeMode);
  } else {
    return formInputTheme.backgroundColor.rest(themeMode);
  }
}
function getBorderWidth(_ref3) {
  let {
    themeMode,
    validationState,
    isFocused,
    focusMode
  } = _ref3;
  if (validationState === "error") {
    return formInputTheme.borderWidth.error(themeMode);
  } else if (isFocused && focusMode !== "keyboard") {
    return formInputTheme.borderWidth.active(themeMode);
  } else {
    return formInputTheme.borderWidth.rest(themeMode);
  }
}
function getStylingState(_ref4) {
  let {
    validationState,
    isFocused,
    focusMode
  } = _ref4;
  if (validationState === "error") {
    return `error`;
  } else if (isFocused && focusMode !== "keyboard") {
    return `active`;
  } else {
    return `rest`;
  }
}
//# sourceMappingURL=formInputTheme.js.map